import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  getOverViewRecheck,
  updateConfig,
} from "../../../../store/slices/OverSlice/overViewSlice";
import { useGetFilterListDataQuery } from "../../../../store/queries/Verification";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const useFilterForm = () => {
  const dispatch = useDispatch();
  const overViewState = useSelector((state) => state.overview);
  const formik = useFormik({
    initialValues: {
      itemType: [],
      shop: "",
      priority: "",
      orderType: null,
    },
    onSubmit: (values) => {
      dispatch(
        updateConfig((state) => {
          state.filter.itemType = values?.itemType;
          state.filter.shop = values?.shop;
          state.filter.priority = values?.priority;
          state.filter.orderType = values?.orderType;
          state.overViewRecheckData = [];
        })
      );
      let itemTypesIds = values?.itemType?.map((values) => values?._id);
      let shopIds = values?.shop?.map((values) => values?._id);
      let statusIds = values?.priority?.map((values) => values?.id);
      dispatch(
        getOverViewRecheck({
          item_type: itemTypesIds,
          shop: shopIds,
          status: statusIds,
          date: overViewState?.recheckDate,
          order_type: values?.orderType?.value || "",
        })
      );
      handleCloseModal();
    },
  });

  useEffect(() => {
    formik?.setFieldValue("itemType", overViewState?.filter?.itemType);
    formik?.setFieldValue("shop", overViewState?.filter?.shop);
    formik?.setFieldValue("priority", overViewState?.filter?.priority);
    formik?.setFieldValue("orderType", overViewState?.filter?.orderType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overViewState]);

  const orderTypeOptions = [
    { label: "Recheck", value: 2 },
    { label: "Reissue", value: 3 },
  ];

  const { data: FilterData = {} } = useGetFilterListDataQuery({});
  const handleCloseModal = () => {
    dispatch(updateConfig((state) => (state.filterModal = !state.filterModal)));
  };

  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  return {
    formik,
    filterFormData: FilterData?.data,
    orderTypeOptions,
    handleCloseModal,
    getFieldError,
  };
};

export default useFilterForm;
